import React, { useEffect, useRef, useState } from "react";
import styles from "./NewUIPackages.module.scss";
import { useLocation, useNavigate } from "react-router-dom";

import { animateScroll as scroll } from "react-scroll";
import { formatIndianCurrency } from "../../../utils/utils";

const NewUIPackageCard = ({
  date: selectedDate,
  imgSrc,
  id,
  title,
  packagehandle,
  packageId,
  duration,
  nightDuration,
  packageHub,
  price,
  bookingLink,
  detailsLink,
  packageHotels,
  canBookable,
  setShowSendEnquiryPopup,
  markupData,
  NoPax,
  packageItinerary,
}) => {
  const navigate = useNavigate();
  const [data, setData] = useState({ fromCity: "", toCity: "" });
  const [departureDate, setdepartureDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [date, setDate] = useState(new Date());
  const [hotelData, setHotelData] = useState([]);
  const [guest, setGuest] = useState(2);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [childAge, setChildAge] = useState([]);
  const [bookingData, setBookingData] = useState({});
  const location = useLocation();
  const [allDestinations, setAllDestinations] = useState([]);

  const queryParams = new URLSearchParams(location.search);
  const checkinDay = queryParams.get("checkinDay") || "";
  const checkinMonth = queryParams.get("checkinMonth") || "";
  const checkinYear = queryParams.get("checkinYear") || "";
  const checkoutDay = queryParams.get("checkoutDay") || "";
  const checkoutMonth = queryParams.get("checkoutMonth") || "";
  const checkoutYear = queryParams.get("checkoutYear") || "";

  const titleRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (titleRef.current) {
      setIsTruncated(
        titleRef.current.scrollWidth > titleRef.current.clientWidth
      );
    }
  }, [title]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    // Get the childAge parameters
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    const data = {
      hotelID: params.get("hotelID"),
      // packageHandle: params.get("packagehandle"),
      // packageId:params.get("packageId"),
      location: params.get("location"),
      room: params.get("room"),
      guest: params.get("guest"),
      children: params.get("children"),
      checkinDay: params.get("checkinDay"),
      checkinMonth: params.get("checkinMonth"),
      checkinYear: params.get("checkinYear"),
      checkoutDay: params.get("checkoutDay"),
      checkoutMonth: params.get("checkoutMonth"),
      checkoutYear: params.get("checkoutYear"),
      radio: params.get("radio"),
      childAge: childAges,
    };

    const checkInDate = `${data.checkinYear}-${String(
      data.checkinMonth
    ).padStart(2, "0")}-${String(data.checkinDay).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    setData({
      fromCity: params.get("location"),
      // toCity: params.get("location"),
    });
    let packagePax = NoPax;
    if (NoPax && NoPax !== null) {
      packagePax = NoPax;
    } else {
      packagePax = 2;
    }

    setGuest(data.guest ? data.guest : packagePax);
    setChildren(data?.children ? data?.children : 0);
    setRooms(data.room);
    setChildAge(childAges);
    setdepartureDate(checkInDate);
    setEndDate(checkOutDate);
    setBookingData(data);
  }, [location.search]);


  const handleSelectRoomClickHandler = async (item, hotelData, room_id) => {
    let hasChildAgeError = false;
    const childAge = bookingData?.childAge;
    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }

    // console.log(children, 'jjj');

    // Calculate booking values before navigating

    const fallbackDate = new Date();
    fallbackDate.setDate(fallbackDate.getDate() + 7);

    try {
      await navigate(
        `/package/${packagehandle}?packageId=${packageId}&location=${data.fromCity
        // }&day=${
        //   selectedDate && selectedDate.setDay
        //     ? selectedDate.setDay
        //     : new Date().getDate()
        // }&month=${
        //   selectedDate && selectedDate.setMonth
        //     ? selectedDate.setMonth
        //     : new Date().getMonth() + 1
        // }&year=${
        //   selectedDate && selectedDate.setYear
        //     ? selectedDate.setYear
        //     : new Date().getFullYear()
        }&day=${selectedDate && selectedDate.day
          ? selectedDate.day
          : fallbackDate.getDate()
        }&month=${selectedDate && selectedDate.month
          ? selectedDate.month
          : fallbackDate.getMonth() + 1
        }&year=${selectedDate && selectedDate.year
          ? selectedDate.year
          : fallbackDate.getFullYear()
        }&guest=${guest}&children=${children}&${childAgeParams}`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [showRatePopup, setshowRatePopup] = useState(false);

  const handleshowRatePopup = (e) => {
    e.stopPropagation();
    setshowRatePopup(!showRatePopup);
  };

  const [formData, setFormData] = useState({
    company_name: "",
    name: "",
    phone: "",
    email: "",
    querry_detail: "",
    country: "",
    state: "",
    city: "",
    address: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  // console.log(showRatePopup);

  const calculatePriceWithMarkup = (basePrice) => {
    if (!markupData) return basePrice;

    const { markupType, amount } = markupData;

    if (markupType === "percentage") {
      const percentageAmount = (parseFloat(amount) / 100) * basePrice;
      return basePrice + percentageAmount;
    }

    if (markupType === "fixed") {
      return basePrice + parseFloat(amount);
    }

    return basePrice; // Default fallback
  };

  const finalPrice = calculatePriceWithMarkup(price);

  const [visibleCount, setVisibleCount] = useState(3);

  useEffect(() => {
    const updateVisibleCount = () => {
      if (window.innerWidth <= 480) {
        setVisibleCount(2);
      } else {
        setVisibleCount(3);
      }
    };

    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  // const calculateNights = (data) => {
  //   let destinations = [];
  //   let currentDestination = null;
  //   let nights = 0;

  //   if (data) {
  //     for (let i = 0; i < data.length; i++) {
  //       const { startDestination, endDestination } = data[i];

  //       // Ignore the first transit destination (like "Chandigarh")
  //       if (i === 0) continue;

  //       if (currentDestination === startDestination) {
  //         nights++; // Continue counting nights
  //       } else {
  //         if (currentDestination) {
  //           destinations.push({
  //             destination: currentDestination,
  //             night: nights,
  //           });
  //         }
  //         currentDestination = startDestination;
  //         nights = 1; // Start new night count
  //       }
  //     }
  //   }

  //   // Push the last counted destination
  //   if (currentDestination) {
  //     destinations.push({ destination: currentDestination, night: nights });
  //   }

  //   return destinations;
  // };

  const calculateNights = (data) => {
    let destinations = [];
    let currentDestination = null;
    let nights = 0;
    if (data) {
      for (let i = 0; i < data.length; i++) {
        const { startDestination, endDestination } = data[i];

        // Ignore the first transit destination (like "Chandigarh")
        if (i === 0) continue;

        if (
          currentDestination?.toLowerCase() === startDestination?.toLowerCase()
        ) {
          nights++; // Continue counting nights
        } else {
          if (currentDestination) {
            destinations.push({
              destination: currentDestination,
              night: nights,
            });
          }
          currentDestination = startDestination;
          nights = 1; // Start new night count
        }
      }
    }

    // Push the last counted destination
    if (currentDestination) {
      destinations.push({ destination: currentDestination, night: nights });
    }

    return destinations;
  };

  useEffect(() => {
    if (packageItinerary) {
      const destinationData = calculateNights(packageItinerary);
      setAllDestinations(destinationData);
    }
  }, [packageItinerary]);

  // const itineraries = ["1N Dharamshala", "2N Dalhousie", "1N Manali", "2N Kinnaur", "1N Shimla"];
  const visibleItems = allDestinations?.slice(0, visibleCount);
  const remainingCount = allDestinations?.length - visibleCount;
  const remainingItems = allDestinations?.slice(visibleCount);
  const remainingText = remainingItems;
  // ?.map((item) => `${item?.night}N ${item?.destination}`)
  // .join(", ");

  return (
    <div className={styles.package_listing_card}>
      <div className={styles.listing_card_data}>
        <div className={styles.img_sec}>
          <img
            onClick={() => {
              handleSelectRoomClickHandler();
              scroll.scrollToTop({ duration: 500, smooth: "easeInOutQuad" });
            }}
            src={imgSrc}
            alt={title}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className={styles.detail_button_align}>
          <div className={styles.content_sec}>
            {/* <h3
              className="cursor_pointer"
              onClick={() => {
                handleSelectRoomClickHandler();
                scroll.scrollToTop({ duration: 500, smooth: "easeInOutQuad" });
              }}
            >
              {title}
            </h3> */}

            <div className={styles.titleContainer}>
              <h3
                style={{ padding: "0" }}
                ref={titleRef}
                className={styles.truncatedTitle}
                onClick={() => {
                  handleSelectRoomClickHandler();
                  scroll.scrollToTop({
                    duration: 500,
                    smooth: "easeInOutQuad",
                  });
                }}
              >
                {title}
              </h3>
              {isTruncated && <span className={styles.fullTitle}>{title}</span>}
            </div>

            <div className={styles.location}>
              <div>
                {/* 
                {`${duration}D/${nightDuration}N`} */}
                {/* <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                  <mask id="mask0_6863_10201" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="15">
                    <rect y="0.5" width="14" height="14" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_6863_10201)">
                    <path d="M7.0585 13.0417C6.28296 13.0417 5.55568 12.8945 4.87668 12.6002C4.19759 12.306 3.60526 11.906 3.0997 11.4005C2.59415 10.8949 2.19423 10.3026 1.89993 9.62349C1.60564 8.94449 1.4585 8.21722 1.4585 7.44168C1.4585 6.32061 1.76178 5.29662 2.36835 4.3697C2.97482 3.44269 3.79518 2.76568 4.82943 2.33868C5.01348 2.2609 5.18755 2.27456 5.35166 2.37966C5.51577 2.48466 5.59861 2.63404 5.60016 2.82781C5.61212 3.63922 5.7705 4.41267 6.07529 5.14816C6.37998 5.88374 6.81841 6.53756 7.39056 7.10962C7.96261 7.68177 8.61454 8.11927 9.34633 8.42212C10.0781 8.72506 10.8497 8.88251 11.6611 8.89447C11.8766 8.89593 12.0348 8.97818 12.1357 9.14122C12.2367 9.30426 12.2483 9.48077 12.1705 9.67074C11.7315 10.6991 11.05 11.518 10.126 12.1275C9.20205 12.7369 8.17957 13.0417 7.0585 13.0417Z" fill="#ECB119" />
                  </g>
                </svg> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                >
                  <mask
                    id="mask0_6863_9644"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="14"
                    height="15"
                  >
                    <rect y="0.5" width="14" height="14" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_6863_9644)">
                    <path
                      d="M7.05825 13.0417C6.28271 13.0417 5.55544 12.8945 4.87644 12.6002C4.19734 12.306 3.60502 11.906 3.09946 11.4005C2.5939 10.8949 2.19398 10.3026 1.89969 9.62349C1.6054 8.94449 1.45825 8.21722 1.45825 7.44168C1.45825 6.32061 1.76154 5.29662 2.36811 4.3697C2.97458 3.44269 3.79494 2.76568 4.82919 2.33868C5.01323 2.2609 5.18731 2.27456 5.35142 2.37966C5.51553 2.48466 5.59836 2.63404 5.59992 2.82781C5.61188 3.63922 5.77025 4.41267 6.07504 5.14816C6.37974 5.88374 6.81816 6.53756 7.39031 7.10962C7.96237 7.68177 8.61429 8.11927 9.34609 8.42212C10.0779 8.72506 10.8495 8.88251 11.6609 8.89447C11.8763 8.89593 12.0345 8.97818 12.1354 9.14122C12.2365 9.30426 12.2481 9.48077 12.1703 9.67074C11.7312 10.6991 11.0497 11.518 10.1257 12.1275C9.20181 12.7369 8.17932 13.0417 7.05825 13.0417Z"
                      fill="#ECB119"
                    />
                  </g>
                </svg>
                {`${nightDuration}N`}
                <span className="flex align_items_center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                  >
                    <mask
                      id="mask0_6863_10206"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="14"
                      height="15"
                    >
                      <rect y="0.5" width="14" height="14" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6863_10206)">
                      <path
                        d="M6.99986 3.54004C6.8758 3.54004 6.77192 3.49814 6.68821 3.41434C6.6044 3.33043 6.5625 3.2265 6.5625 3.10254V1.82373C6.5625 1.69977 6.60445 1.59589 6.68836 1.51208C6.77226 1.42818 6.87619 1.38623 7.00015 1.38623C7.1242 1.38623 7.22809 1.42818 7.31179 1.51208C7.3956 1.59589 7.4375 1.69977 7.4375 1.82373V3.10254C7.4375 3.2265 7.39555 3.33043 7.31165 3.41434C7.22775 3.49814 7.12381 3.54004 6.99986 3.54004ZM9.79781 4.70219C9.71702 4.62149 9.67755 4.5215 9.6794 4.40221C9.68124 4.28292 9.72256 4.17801 9.80336 4.0875L10.6929 3.17779C10.7807 3.08728 10.885 3.04202 11.0056 3.04202C11.1263 3.04202 11.2322 3.08767 11.3235 3.17896C11.4072 3.26267 11.4491 3.3647 11.4491 3.48506C11.4491 3.60552 11.4068 3.70799 11.3222 3.79248L10.4125 4.70219C10.328 4.78677 10.2255 4.82906 10.1051 4.82906C9.98472 4.82906 9.8823 4.78677 9.79781 4.70219ZM11.3975 7.9375C11.2735 7.9375 11.1696 7.89555 11.0857 7.81165C11.0019 7.72774 10.96 7.62381 10.96 7.49986C10.96 7.3758 11.0019 7.27192 11.0857 7.18821C11.1696 7.1044 11.2735 7.0625 11.3975 7.0625H12.6763C12.8002 7.0625 12.9041 7.10445 12.9879 7.18836C13.0718 7.27226 13.1138 7.37619 13.1138 7.50015C13.1138 7.6242 13.0718 7.72808 12.9879 7.81179C12.9041 7.8956 12.8002 7.9375 12.6763 7.9375H11.3975ZM6.99986 13.6138C6.8758 13.6138 6.77192 13.5718 6.68821 13.4879C6.6044 13.4041 6.5625 13.3002 6.5625 13.1763V11.903C6.5625 11.779 6.60445 11.6752 6.68836 11.5914C6.77226 11.5075 6.87619 11.4655 7.00015 11.4655C7.1242 11.4655 7.22809 11.5075 7.31179 11.5914C7.3956 11.6752 7.4375 11.779 7.4375 11.903V13.1763C7.4375 13.3002 7.39555 13.4041 7.31165 13.4879C7.22775 13.5718 7.12381 13.6138 6.99986 13.6138ZM3.59319 4.70219L2.67779 3.80706C2.58728 3.71966 2.54202 3.61403 2.54202 3.49017C2.54202 3.3664 2.58728 3.26228 2.67779 3.17779C2.76228 3.097 2.86597 3.05661 2.98886 3.05661C3.11174 3.05661 3.21295 3.097 3.29248 3.17779L4.20788 4.09319C4.28867 4.17272 4.32906 4.27393 4.32906 4.39681C4.32906 4.5197 4.28906 4.62149 4.20904 4.70219C4.12174 4.78298 4.0199 4.82338 3.90352 4.82338C3.78705 4.82338 3.68361 4.78298 3.59319 4.70219ZM10.6986 11.8222L9.80336 10.9125C9.72256 10.822 9.68124 10.7171 9.6794 10.5978C9.67755 10.4785 9.71663 10.3785 9.79665 10.2978C9.87666 10.217 9.9767 10.1766 10.0968 10.1766C10.2167 10.1766 10.322 10.2189 10.4125 10.3034L11.3222 11.1986C11.409 11.2793 11.4509 11.3808 11.4479 11.5031C11.4449 11.6254 11.4025 11.7318 11.3206 11.8222C11.2313 11.9127 11.1251 11.958 11.0023 11.958C10.8793 11.958 10.7781 11.9127 10.6986 11.8222ZM1.32373 7.9375C1.19977 7.9375 1.09589 7.89555 1.01208 7.81165C0.928182 7.72774 0.88623 7.62381 0.88623 7.49986C0.88623 7.3758 0.928182 7.27192 1.01208 7.18821C1.09589 7.1044 1.19977 7.0625 1.32373 7.0625H2.60254C2.7265 7.0625 2.83043 7.10445 2.91433 7.18836C2.99814 7.27226 3.04004 7.37619 3.04004 7.50015C3.04004 7.6242 2.99814 7.72808 2.91433 7.81179C2.83043 7.8956 2.7265 7.9375 2.60254 7.9375H1.32373ZM2.68333 11.8222C2.60254 11.7377 2.56122 11.6343 2.55938 11.512C2.55753 11.3898 2.597 11.2883 2.67779 11.2075L3.58196 10.3034C3.66645 10.2189 3.76741 10.1766 3.88486 10.1766C4.0022 10.1766 4.10613 10.2185 4.19665 10.3022C4.28716 10.3935 4.33242 10.4988 4.33242 10.6181C4.33242 10.7374 4.28716 10.8422 4.19665 10.9326L3.30706 11.8222C3.21655 11.9127 3.10985 11.958 2.98696 11.958C2.86407 11.958 2.76286 11.9127 2.68333 11.8222ZM7.00131 10.7083C6.11047 10.7083 5.35281 10.3965 4.72836 9.77296C4.1039 9.14938 3.79167 8.39216 3.79167 7.50131C3.79167 6.61047 4.10346 5.85281 4.72704 5.22836C5.35063 4.6039 6.10784 4.29167 6.99869 4.29167C7.88954 4.29167 8.64719 4.60346 9.27165 5.22704C9.89611 5.85063 10.2083 6.60784 10.2083 7.49869C10.2083 8.38954 9.89654 9.14719 9.27296 9.77165C8.64938 10.3961 7.89216 10.7083 7.00131 10.7083Z"
                        fill="#ECB119"
                      />
                    </g>
                  </svg>
                  {`${duration}D`}
                </span>
              </div>
              <div>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_5983_7301"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="18"
                    height="18"
                  >
                    <rect width="18" height="18" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_5983_7301)">
                    <path
                      d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </svg>
                {packageHub}
              </div>
            </div>

            {visibleItems && visibleItems.length > 0 && (
              <div className={styles.packageItenaries}>
                {visibleItems.map((item, index) => (
                  <span key={index} className="text-uppercase">
                    <span>{item?.night}N</span> {item?.destination}
                  </span>
                ))}
                {remainingCount > 0 && (
                  <div className={styles.itinerary_tooltip}>
                    <span className={styles.moreText}>
                      +{remainingCount} More
                    </span>
                    <div className={styles.itinerary_tooltip_text}>
                      {remainingItems.map((item, index) => (
                        <span key={index}>
                          {item?.night}N {item?.destination}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div>
            <div className={styles.plan}>
              <div className={styles.plan_sec_main}>
                {packageItinerary?.some((item) => item.pickup || item.drop) && (
                  <div>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_5990_6383"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5990_6383)">
                        <path
                          d="M4.359 15V16.1538C4.359 16.2963 4.309 16.4174 4.209 16.5171C4.10886 16.6168 3.98726 16.6667 3.84421 16.6667C3.70129 16.6667 3.58046 16.6168 3.48171 16.5171C3.38282 16.4174 3.33337 16.2963 3.33337 16.1538V10.3558C3.33337 10.28 3.33768 10.2041 3.34629 10.1281C3.35476 10.0523 3.37164 9.97681 3.39692 9.90167L4.819 5.90062C4.90761 5.63382 5.06824 5.41701 5.30087 5.25021C5.53351 5.0834 5.79379 5 6.08171 5H13.9184C14.2063 5 14.4666 5.0834 14.6992 5.25021C14.9318 5.41701 15.0925 5.63382 15.1811 5.90062L16.6032 9.90167C16.6284 9.97681 16.6453 10.0523 16.6538 10.1281C16.6624 10.2041 16.6667 10.28 16.6667 10.3558V16.1538C16.6667 16.2963 16.6166 16.4174 16.5165 16.5171C16.4165 16.6168 16.295 16.6667 16.1519 16.6667C16.009 16.6667 15.8881 16.6168 15.7892 16.5171C15.6905 16.4174 15.6411 16.2963 15.6411 16.1538V15H4.359ZM4.51296 9.29479H15.4871L14.388 6.16979C14.3452 6.06299 14.281 5.98021 14.1955 5.92146C14.11 5.86271 14.0086 5.83333 13.8911 5.83333H6.109C5.9915 5.83333 5.89004 5.86271 5.80462 5.92146C5.71907 5.98021 5.6549 6.06299 5.61212 6.16979L4.51296 9.29479ZM6.18962 13.0769C6.44893 13.0769 6.66803 12.9862 6.84692 12.8048C7.02594 12.6233 7.11546 12.4029 7.11546 12.1438C7.11546 11.8844 7.02469 11.6653 6.84317 11.4865C6.66178 11.3074 6.44143 11.2179 6.18212 11.2179C5.92296 11.2179 5.70386 11.3087 5.52483 11.4902C5.34594 11.6716 5.2565 11.8919 5.2565 12.1513C5.2565 12.4104 5.34719 12.6295 5.52858 12.8085C5.71011 12.9874 5.93046 13.0769 6.18962 13.0769ZM13.818 13.0769C14.0771 13.0769 14.2962 12.9862 14.4752 12.8048C14.6541 12.6233 14.7436 12.4029 14.7436 12.1438C14.7436 11.8844 14.6529 11.6653 14.4715 11.4865C14.29 11.3074 14.0696 11.2179 13.8105 11.2179C13.5512 11.2179 13.3321 11.3087 13.1532 11.4902C12.9741 11.6716 12.8846 11.8919 12.8846 12.1513C12.8846 12.4104 12.9754 12.6295 13.1569 12.8085C13.3383 12.9874 13.5587 13.0769 13.818 13.0769ZM4.16671 14.1667H15.8334V10.1281H4.16671V14.1667Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                    Transfer
                  </div>
                )}
                {packageItinerary?.some(
                  (item) => item.accommodation?.length > 0
                ) && (
                    <>
                      <div>
                        <svg
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_5990_6388"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="21"
                            height="20"
                          >
                            <rect
                              x="0.888916"
                              width="20"
                              height="20"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_5990_6388)">
                            <path
                              d="M7.13892 12.4038H14.6389V13.2852C14.6389 13.391 14.6739 13.479 14.7439 13.549C14.8139 13.6188 14.9018 13.6538 15.0075 13.6538C15.1133 13.6538 15.2012 13.6188 15.2712 13.549C15.3411 13.479 15.376 13.391 15.376 13.2852V10.6762C15.376 10.3024 15.2588 9.98694 15.0243 9.73C14.7899 9.47306 14.4904 9.32694 14.126 9.29167V8.20521C14.126 7.8216 13.9975 7.50132 13.7406 7.24437C13.4836 6.98743 13.1634 6.85896 12.78 6.85896H8.99787C8.6144 6.85896 8.29419 6.98743 8.03725 7.24437C7.7803 7.50132 7.65183 7.8216 7.65183 8.20521V9.29167C7.28739 9.32694 6.98794 9.47306 6.7535 9.73C6.51905 9.98694 6.40183 10.3024 6.40183 10.6762V13.2852C6.40183 13.391 6.43676 13.479 6.50662 13.549C6.57662 13.6188 6.66454 13.6538 6.77037 13.6538C6.87607 13.6538 6.96392 13.6188 7.03392 13.549C7.10392 13.479 7.13892 13.391 7.13892 13.2852V12.4038ZM7.13892 11.6667V10.6762C7.13892 10.4818 7.20301 10.3205 7.33121 10.1923C7.4594 10.0641 7.62072 10 7.81517 10H13.9627C14.1571 10 14.3184 10.0641 14.4466 10.1923C14.5748 10.3205 14.6389 10.4818 14.6389 10.6762V11.6667H7.13892ZM8.38892 9.26292V8.10896C8.38892 7.95937 8.43697 7.83653 8.53308 7.74042C8.62933 7.6443 8.75225 7.59625 8.90183 7.59625H12.876C13.0256 7.59625 13.1485 7.6443 13.2448 7.74042C13.3409 7.83653 13.3889 7.95937 13.3889 8.10896V9.26292H8.38892ZM4.73517 17.5C4.35155 17.5 4.03128 17.3715 3.77433 17.1146C3.51739 16.8576 3.38892 16.5374 3.38892 16.1538V3.84625C3.38892 3.46264 3.51739 3.14236 3.77433 2.88542C4.03128 2.62847 4.35155 2.5 4.73517 2.5H17.0427C17.4263 2.5 17.7466 2.62847 18.0035 2.88542C18.2604 3.14236 18.3889 3.46264 18.3889 3.84625V16.1538C18.3889 16.5374 18.2604 16.8576 18.0035 17.1146C17.7466 17.3715 17.4263 17.5 17.0427 17.5H4.73517ZM4.73517 16.6667H17.0427C17.171 16.6667 17.2886 16.6133 17.3954 16.5065C17.5022 16.3997 17.5556 16.2821 17.5556 16.1538V3.84625C17.5556 3.71792 17.5022 3.60035 17.3954 3.49354C17.2886 3.38674 17.171 3.33333 17.0427 3.33333H4.73517C4.60683 3.33333 4.48926 3.38674 4.38246 3.49354C4.27565 3.60035 4.22225 3.71792 4.22225 3.84625V16.1538C4.22225 16.2821 4.27565 16.3997 4.38246 16.5065C4.48926 16.6133 4.60683 16.6667 4.73517 16.6667Z"
                              fill="#333333"
                            />
                          </g>
                        </svg>
                        Stay
                      </div>
                      <div>
                        <svg
                          width="17"
                          height="19"
                          viewBox="0 0 14 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.08982 15.5C2.97162 15.5 2.87273 15.4601 2.79315 15.3802C2.71357 15.3003 2.67378 15.2014 2.67378 15.0833V8.38396C1.92378 8.19215 1.34628 7.85903 0.941276 7.38458C0.536415 6.91028 0.333984 6.33014 0.333984 5.64417V0.916667C0.333984 0.798611 0.373984 0.699653 0.453984 0.619792C0.533984 0.539931 0.633082 0.5 0.751276 0.5C0.86947 0.5 0.968359 0.539931 1.04794 0.619792C1.12753 0.699653 1.16732 0.798611 1.16732 0.916667V5.2275H2.67378V0.916667C2.67378 0.798611 2.71378 0.699653 2.79378 0.619792C2.87364 0.539931 2.97266 0.5 3.09086 0.5C3.20919 0.5 3.30815 0.539931 3.38773 0.619792C3.46732 0.699653 3.50711 0.798611 3.50711 0.916667V5.2275H5.01357V0.916667C5.01357 0.798611 5.0535 0.699653 5.13336 0.619792C5.21336 0.539931 5.31246 0.5 5.43065 0.5C5.54885 0.5 5.64773 0.539931 5.72732 0.619792C5.80704 0.699653 5.8469 0.798611 5.8469 0.916667V5.64417C5.8469 6.33014 5.6444 6.91028 5.2394 7.38458C4.83454 7.85903 4.25711 8.19215 3.50711 8.38396V15.0833C3.50711 15.2014 3.46711 15.3003 3.38711 15.3802C3.30711 15.4601 3.20801 15.5 3.08982 15.5ZM10.8944 15.5C10.7761 15.5 10.6771 15.4601 10.5975 15.3802C10.5179 15.3003 10.4782 15.2014 10.4782 15.0833V8.10729C9.72815 7.8466 9.15072 7.38639 8.74586 6.72667C8.341 6.06694 8.13857 5.26757 8.13857 4.32854C8.13857 3.2741 8.40843 2.37236 8.94815 1.62333C9.48801 0.874444 10.1369 0.5 10.8948 0.5C11.6573 0.5 12.31 0.875277 12.8529 1.62583C13.3959 2.37639 13.6673 3.27889 13.6673 4.33333C13.6673 5.28306 13.4622 6.08701 13.0519 6.74521C12.6416 7.40326 12.0615 7.85521 11.3115 8.10104V15.0833C11.3115 15.2014 11.2716 15.3003 11.1917 15.3802C11.1117 15.4601 11.0126 15.5 10.8944 15.5Z"
                            fill="#666666"
                          />
                        </svg>
                        Meals
                      </div>
                    </>
                  )}

                {packageItinerary?.some(
                  (item) => item.activity?.length > 0
                ) && (
                    <div>
                      <svg
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_5990_6398"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="21"
                          height="20"
                        >
                          <rect
                            x="0.666748"
                            width="20"
                            height="20"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_5990_6398)">
                          <path
                            d="M10.6667 13.2642C10.3599 13.2642 10.0951 13.148 9.87258 12.9157C9.64992 12.6834 9.53858 12.4072 9.53858 12.087C9.53858 11.7667 9.64992 11.4905 9.87258 11.2583C10.0951 11.0259 10.3599 10.9097 10.6667 10.9097C10.9736 10.9097 11.2384 11.0259 11.4609 11.2583C11.6836 11.4905 11.7949 11.7667 11.7949 12.087C11.7949 12.4072 11.6836 12.6834 11.4609 12.9157C11.2384 13.148 10.9736 13.2642 10.6667 13.2642ZM9.00008 18V15.6696C8.14453 15.4128 7.51269 14.961 7.10458 14.3144C6.69647 13.6678 6.44925 12.9217 6.36291 12.0762C6.34925 11.9826 6.37553 11.903 6.44175 11.8374C6.50797 11.7719 6.58725 11.7391 6.67958 11.7391C6.77191 11.7391 6.85053 11.7726 6.91541 11.8395C6.98041 11.9064 7.01975 11.9911 7.03341 12.0936C7.13942 13.1568 7.50075 13.9432 8.11741 14.4529C8.73408 14.9626 9.58386 15.2174 10.6667 15.2174C11.7471 15.2174 12.595 14.9626 13.2104 14.4529C13.8257 13.9432 14.189 13.1608 14.3001 12.1057C14.3137 11.9978 14.3524 11.9097 14.4161 11.8414C14.4797 11.7732 14.559 11.7391 14.6539 11.7391C14.7488 11.7391 14.8281 11.7739 14.8917 11.8435C14.9554 11.913 14.9804 11.996 14.9667 12.0923C14.889 12.9351 14.646 13.6778 14.2379 14.3203C13.8298 14.963 13.195 15.4128 12.3334 15.6696V18H9.00008ZM6.08975 10.3666L4.75641 6.9713C4.5983 7.04168 4.45047 7.11368 4.31291 7.1873C4.17525 7.26093 4.07097 7.29774 4.00008 7.29774C3.91375 7.29774 3.83664 7.26446 3.76875 7.19791C3.70075 7.13148 3.66675 7.04881 3.66675 6.94991V4.6087C3.66675 3.91038 4.33214 3.30099 5.66291 2.78052C6.99369 2.26017 8.66164 2 10.6667 2C12.6719 2 14.3398 2.26017 15.6706 2.78052C17.0014 3.30099 17.6667 3.91038 17.6667 4.6087V6.94991C17.6667 7.04881 17.6327 7.13148 17.5647 7.19791C17.4969 7.26446 17.4197 7.29774 17.3334 7.29774C17.2625 7.29774 17.1582 7.26093 17.0206 7.1873C16.883 7.11368 16.7352 7.04168 16.5771 6.9713L15.2437 10.3452C15.2137 10.4281 15.1631 10.4939 15.0917 10.5424C15.0204 10.591 14.9437 10.6153 14.8616 10.6153H14.6192C14.515 10.6153 14.426 10.5868 14.3521 10.5297C14.2781 10.4727 14.2287 10.3897 14.2039 10.2809L13.2692 6.02278C12.8171 5.95588 12.3753 5.90638 11.9437 5.87426C11.5121 5.84215 11.0864 5.82609 10.6667 5.82609C10.2471 5.82609 9.82141 5.84215 9.38975 5.87426C8.95819 5.90638 8.51636 5.95588 8.06425 6.02278L7.12958 10.3023C7.1048 10.3995 7.05608 10.4761 6.98341 10.5318C6.91075 10.5875 6.82786 10.6153 6.73475 10.6153H6.45141C6.37186 10.6153 6.29919 10.5923 6.23341 10.5464C6.16764 10.5005 6.11975 10.4406 6.08975 10.3666ZM6.58341 10.0134L7.42058 6.12974C7.01547 6.21716 6.65691 6.30365 6.34491 6.38922C6.03303 6.4749 5.68947 6.59664 5.31425 6.75444L6.58341 10.0134ZM14.7501 10.0094L16.0192 6.75444C15.6356 6.60557 15.2899 6.48609 14.9821 6.396C14.6744 6.30591 14.318 6.21716 13.9129 6.12974L14.7501 10.0094ZM4.33341 6.4C5.25053 5.97194 6.25075 5.65333 7.33408 5.44417C8.41742 5.23501 9.5283 5.13043 10.6667 5.13043C11.8052 5.13043 12.9161 5.23501 13.9994 5.44417C15.0827 5.65333 16.083 5.97194 17.0001 6.4V4.56313C16.936 4.35803 16.7494 4.14783 16.4404 3.93252C16.1315 3.7171 15.7115 3.51571 15.1802 3.32835C14.649 3.1411 14.0059 2.98887 13.2507 2.87165C12.4956 2.75432 11.6343 2.69565 10.6667 2.69565C9.69919 2.69565 8.83786 2.75432 8.08275 2.87165C7.32764 2.98887 6.68447 3.1411 6.15325 3.32835C5.62203 3.51571 5.20197 3.7171 4.89308 3.93252C4.58408 4.14783 4.39753 4.35803 4.33341 4.56313V6.4Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                      Activity
                    </div>
                  )}
              </div>
              <div className={styles.pricing_details}>
                {/* <div className={styles.discount_btn}>20% off</div>{" "} */}
                <div className={styles.price_info}>
                  <h4>{formatIndianCurrency(finalPrice)}</h4>
                  <small>Value Package for {NoPax ? NoPax : 2} Pax</small>
                </div>
              </div>
            </div>
            <button
              className={styles.view_btn}
              onClick={() => {
                handleSelectRoomClickHandler();
                scroll.scrollToTop({ duration: 500, smooth: "easeInOutQuad" });
              }}
            >
              {" "}
              View Details
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewUIPackageCard;
